export default __webpack_public_path__ + "static/media/download-bg.4fe24730.png";